import React, { useState } from "react";

const AttendanceCalculator = () => {
  const [present, setPresent] = useState("");
  const [total, setTotal] = useState("");
  const [percentage, setPercentage] = useState(null);

  const calculateAttendance = () => {
    setPercentage(((present / total) * 100).toFixed(2));
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Attendance Calculator</h2>
      <input
        type="number"
        placeholder="Days Present"
        className="border p-2 w-full mt-2"
        onChange={(e) => setPresent(e.target.value)}
      />
      <input
        type="number"
        placeholder="Total Days"
        className="border p-2 w-full mt-2"
        onChange={(e) => setTotal(e.target.value)}
      />
      <button
        className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full"
        onClick={calculateAttendance}
      >
        Calculate
      </button>
      {percentage && (
        <div className="mt-3 text-center text-lg">
          Attendance: <span className="font-bold text-green-600">{percentage}%</span>
        </div>
      )}
    </div>
  );
};

export default AttendanceCalculator;
